import { canAssignRole } from '@/constants/rolesHierarchy';
import { roles } from '@/MOCK/quickCreationMockData';
import { OptionItem } from '@/types/common';
import { IUserRoles, IUser } from 'redux/user/user.types';

export const getAvailableRolesByHierarchy = (currentUser: IUser): Array<OptionItem<IUserRoles>> => {
  if (['admin', 'developmentDirector'].includes(currentUser.role)) {
    return Object.entries(roles).map(([key, value]) => ({
      title: value,
      value: key as IUserRoles,
      type: 'role',
    }));
  }

  return Object.entries(roles)
    .filter(([targetRole]) => canAssignRole(currentUser.role, targetRole as IUserRoles))
    .map(([key, value]) => ({
      title: value,
      value: key as IUserRoles,
      type: 'role',
    }));
};
